import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, LinearProgress } from '@material-ui/core';
import { CodingGameApi } from 'app/api/codingGameApi';
import { questionTypeEnum } from 'app/utils/QuestionTypeEnum';
import Editor from '@monaco-editor/react';
import { Alert } from '@material-ui/lab';


export default function CodingGameAnswer(props) {

    const [answer, setAnswer] = useState(props.codingGame.baseCode);
    const [testsRunResult, setTestsRunResult] = useState([]);
    const [isFetchingTestResult, setIsFetchingTestResult] = useState(false);

    function testMainCode() {

        const codingGameToTest = ({
            class: questionTypeEnum.CodingGameType,
            baseCode: answer,
            testsCode: props.codingGame.testsCode
        });

        setIsFetchingTestResult(true); 
        CodingGameApi.runTests(codingGameToTest)
            .then((response) => {
                setTestsRunResult([response?.data.message]);
            })
            .catch((error) => {
                const errorMessage = error?.response?.data.message || error?.message || 'An error occurred';
                setTestsRunResult([errorMessage]);
            }).finally(() => {
                setIsFetchingTestResult(false); 
            });
    }

    return (
        <div>
            {props.isHistory || props.codingGame.executionStatus && (
                <Alert severity={props.codingGame.executionStatus === 'SUCCESS' ? 'success' : 'error'} className="tutorial">
                    <div>{props.codingGame.message}</div>
                </Alert>
            )}
            <Editor
                height="70vh"
                defaultLanguage="java"
                defaultValue={props.isHistory ? props.codingGame.submittedCode : props.codingGame.baseCode}
                onChange={(value) => { props.setAnswerCode(value); setAnswer(value); }}
                theme="vs-dark"
                options={{
                    selectOnLineNumbers: true,
                    minimap: { enabled: true },
                    readOnly: props.isHistory,
                }}
            />
            {isFetchingTestResult &&
                            <LinearProgress
                                style={{ marginTop: '8px' }}
                            />
            }
            {!props.isHistory && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => testMainCode()}
                    disabled={isFetchingTestResult}
                    style={{ height: '100%', marginTop: '5px' }}
                >
                    Tester
                </Button>
            )}

            <div
                style={{ marginTop: '5px' }}>
                {testsRunResult}
            </div>
        </div>
    );
};

CodingGameAnswer.propTypes = {
    codingGame: PropTypes.object,
    isHistory: PropTypes.bool,
    setAnswerCode: PropTypes.func
};